<template>
<div class="am-edit-main">
  <div class="am-header am-main-top-box">
    <div class="am-title am-main-top-box-title">{{title}}</div>
    <div class="am-header-icons">
      <a @click="goBack">
        <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="back" title="Back"></svg-icon>
      </a>
    </div>
  </div>
  <table class="am-finance-edit-table">
    <tbody>
      <tr>
        <td class="select-finance"><strong><span>Finance Co</span></strong>:</td>
        <td>
          <select class="finance-dropdown" v-model="premiumFinance.compID" @change="getFinanceAgreement(financeCompany)">
            <option :value="financeCompany.id">{{financeCompany.name}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td><strong><span>Total Premium</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.premium" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>Policy Fee</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.policyFee" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>Tax</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.tax" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>MGA Fee</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.mgaFee" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>Down Payment</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.downPayment" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>Amount Financed</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.amountFinanced" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>APR</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.APR" v-bind="percentage"></money>
        </td>
      </tr>
      <tr>
        <td><strong><span>Date Financed</span></strong>:</td>
        <td>
        <input type="date" id="date-finance-edit" class="input-finance" v-model="premiumFinance.dateFinanced">
        </td>
      </tr>
      <tr>
        <td><strong><span># Payments</span></strong>:</td>
        <td>
          <input type="number" class="input-finance" v-model="premiumFinance.numberPayments" maxlength="25">
        </td>
      </tr>
      <tr>
        <td><strong><span>Payment Amount</span></strong>:</td>
        <td>
          <money class="input-finance" v-model="premiumFinance.paymentAmount" v-bind="money"></money>
        </td>
      </tr>
      <tr>
        <td class="select-finance"><strong><span>Status</span></strong>:</td>
        <td>
          <select class="finance-dropdown" v-model="premiumFinance.contractStatus">
            <option value='Quoted'>Quoted</option>
            <option value='Approved'>Approved</option>
          </select>
        </td>
      </tr>
      <tr>
        <td><strong><span>Contract #</span></strong>:</td>
        <td>
        <input type="text" class="input-finance" v-model="premiumFinance.contractNumber">
        </td>
      </tr>
      <tr>
        <td><strong><span>Agreement #</span></strong>:</td>
        <td>
        <input type="text" class="input-finance" v-model="premiumFinance.agreementID">
        </td>
      </tr>
      <tr>
        <td><strong><span>Paid to Agency</span></strong>:</td>
        <td><yes-no-switch v-model="premiumFinance.paidToAgency"></yes-no-switch></td>
      </tr>
      <tr>
        <td><strong><span>Finance Memo</span></strong>:</td>
        <td>
          <textarea rows="10" cols="10" id="finance-text" class="input-finance" v-model="premiumFinance.memo"></textarea>
        </td>
      </tr>
      <tr v-if="financeAgreement !== ''">
        <td><strong><span>Finance Agreement</span></strong>:</td>
        <td>
          <a :href="financeAgreement" class="am-pointer">Print {{agreementName}} Finance Agreement</a>
        </td>
      </tr>
    </tbody>
    </table>
    <div class="am-bottom-ribbon am-main-bottom-box">
      <button class="am-save-button" @click="onSubmit">
        <img src="@/assets/save.png">
      </button>
    </div>
</div>
</template>
<script>
import api from '../../http'
import moment from 'moment'
import FinanceTab from '../FinanceTab'

export default {
  name: 'FinanceEdit',

  data () {
    return {
      selectedComponent: '',
      title: '',
      premiumFinance: {},
      financeAgreement: '',
      agreementName: '',
      integratedPermission: this.$store.state.auth.permissions.PRadmin === 1 || this.$store.state.auth.permissions.PRowner === 1 || this.$store.state.auth.permissions.PRbackOffice === 1,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        masked: false
      },
      percentage: {
        decimal: '.',
        thousands: ',',
        suffix: ' %',
        masked: false
      }
    }
  },

  asyncComputed: {
    financeCompany: {
      get () {
        let self = this
        return api.makeRequest('finance/companies').then(
          (data) => {
            let financeCompany = data.data.results.find(company => company.id === self.editRow.compID)
            self.getFinanceAgreement(financeCompany)
            return financeCompany
          }
        )
      },
      default: []
    }
  },

  mounted () {
    this.title = (typeof this.editRow.id === 'undefined') ? 'Add' : 'Edit'
    this.premiumFinance = Object.assign({}, this.editRow)
    this.premiumFinance.dateFinanced = moment(this.premiumFinance.dateFinanced).format('YYYY-MM-DD')
  },

  methods: {
    onSubmit () {
      let self = this
      let data = this.premiumFinance
      if(this.title === 'Add') {
        api.postRequest('finance/', data).then(
          (data) => {
            self.goBack()
          }
        )
      }
      else {
        api.putRequest('finance/' + this.premiumFinance.id, data).then(
          (data) => {
            self.goBack()
          })
      }
    },

    goBack () {
      this.$emit('refreshList', this.isViewScreen)
      if(!this.isViewScreen){
        this.$emit('changeComponent', '')
      }
    },
    getFinanceAgreement (financeCompany) {
      this.financeAgreement = ''
      this.agreementName = ''
      if(typeof financeCompany.finance_company_details !== 'undefined' && financeCompany.finance_company_details.isIntegrated === 0) {
        switch(financeCompany.premiumfinancesystem) {
          case 'GOTO':
            if(this.$store.state.auth.permissions.PRadmGPFagreement === 1 || this.integratedPermission) {
              this.agreementName = 'GPF'
              this.financeAgreement = 'pdf/GPF_Application.pdf'
            }
            break
          case 'Unisoft':
            if(this.$store.state.auth.permissions.PRadmFinanceAgreement === 1 || this.integratedPermission) {
              this.agreementName = 'ETI'
              this.financeAgreement = 'pdf/ETI_Application.pdf'
            }
            break
          default:
            this.agreementName = ''
            this.financeAgreement = ''
        }
      }
    }
  },

  props: {
    editRow: Object,
    isViewScreen: Boolean
  },
  components: {
    FinanceTab
  }
}
</script>

<style scoped>
  .finance-dropdown{
    background-color: #ffffef;
  }
  .am-finance-edit-table {
    width: 1230px;
    margin: 10px 10px 10px 10px;
  }
  .am-finance-edit-table td {
    font-size: 11px;
    padding-left: 5px;
  }
  .am-finance-edit-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }
  .am-finance-edit-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }
  .am-finance-edit-table select {
    background-color: #ffffef;
    width: 200px;
    height: 18px;
  }
  #date-finance-edit {
    height: 22px;
    width: 200px;
    -webkit-appearance: none;
  }
  .input-finance {
    background-color: #ffffef;
    margin-top: 1px;
    height: 20px;
    width: 200px;
    padding:2px 5px 2px 1px;
  }

  #finance-text {
    overflow: auto;
    resize: vertical;
    height: 100px;
    width: 320px;
  }

  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-header-icons {
    padding: 6px 15px;
    float: right;
  }

  .am-pointer {
    cursor: pointer;
  }

  .am-bottom-ribbon {
    height: 35px;
  }

  .am-save-button {
    background: transparent;
    border: none;
    margin-top: 3.5px;
    margin-left: 3px;
  }
</style>
